import React, { createContext, useState, ReactNode, useEffect } from 'react';
import { Suits1, SuitSymbols, Ranks, DealSeats, CardSeats } from './BridgeTypes';

export interface Cards {
    id: string;
    rank: string;
    suit: string;
    suitSuit: string;
    
    seat: CardSeats;
    revealed: boolean;
}

// deck history.
const decks: Cards[][] = [];

// DeckContext.
export interface DeckStateContextValue {
    deck: Cards[];

    initialDeck: () => Cards[];
    updateCardSeat: (id: string, seat: CardSeats) => void;
    updateCardRevealed: (id: string, revealed: boolean) => void;
    saveDeck: (turn: number) => void;
    restoreDeck: (turn: number) => void;
}

const initialDeckContextValue = {
    deck: [],
    
    initialDeck: () => [],
    updateCardSeat: () => { },
    updateCardRevealed: () => { },
    saveDeck: () => {},
    restoreDeck: () => {},
}

export const DeckStateContext = createContext<DeckStateContextValue>(initialDeckContextValue);
export const DeckContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [deck, setDeck] = useState<Cards[]>(initialDeckContextValue.deck);

    useEffect(() => {
        setDeck(initialDeck());
    }, []);

    const initialDeck = (): Cards[] => {
        return Suits1.flatMap((suit) => Ranks.map((rank) => ({
            id: `${rank}${suit}`,
            rank,
            suit,
            suitSuit: SuitSymbols[Suits1.indexOf(suit)],
            seat: 'off',
            revealed: false,
        } as Cards)));
    };
    
    const updateCardSeat = (id: string, seat: CardSeats) => {
        setDeck((prevDeck) => {
            const updatedDeck = prevDeck.map((card) => {
                if (card.id === id) {
                    return { ...card, seat };
                }
                return card;
            });
            return updatedDeck;
        });
    };

    const updateCardRevealed = (id: string, revealed: boolean) => {
        setDeck((prevDeck) => {
            const updatedDeck = prevDeck.map((card) => {
                if (card.id === id) {
                    return { ...card, revealed };
                }
                return card;
            });
            return updatedDeck;
        });
    };
    
    const saveDeck = (guess: number) => {
        decks[guess] = deck.map(card => ({ ...card }));
    }

    const restoreDeck = (guess: number) => {
        setDeck(() => {
            return decks[guess].map(card => ({ ...card }));
        });
    }
    
    return (
        <DeckStateContext.Provider value={{
            deck,
            initialDeck,
            updateCardSeat,
            updateCardRevealed,
            saveDeck,
            restoreDeck,
        }}>
            {children}
        </DeckStateContext.Provider>
    );
}

export default DeckContextProvider;